var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFold1Decoration3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 447,
    viewBox: "0 0 476 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00032 29.8021C82.5693 -55.0815 150.17 82.3779 355.955 166.558C561.741 250.738 439.528 286.414 428.444 288.919C417.361 291.424 220.782 322.805 237.038 402.204C253.294 481.603 100.746 436.629 60.9084 395.632C21.0707 354.635 1.00032 231.65 1.00032 231.65",
    stroke: "#CDD6FF",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75316,
    cy: 3.75316,
    r: 3.75316,
    transform: "matrix(-1 0 0 1 69.8081 0)",
    fill: "#A7B7FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-1 0 0 1 242.577 395.711)",
    fill: "#A7B7FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold1Decoration3);
export default __webpack_public_path__ + "static/media/fold-1-decoration3.f17fbf16937cbbf635a3fa84a3fa78d6.svg";
export { ForwardRef as ReactComponent };